import React, { FC, useEffect, useState, useRef, useCallback } from "react";
import axiosInstant from "../../../../api";
import { SingleFilter } from "./singleFilter";
import { ISingleOption, getFilterProps } from "./helper";
import { ISinglePro } from "../../../../components/singlePro/state";
import { useUser } from "../../../../hooks/useUser";
import { isInternal } from "../../../../utils";
import { IconExpert } from "../../../../utils/icons";
import { cldUrl } from "../../../../utils/cloudinary";
import { useWorkspaceBrandId } from '../../../../hooks/useWorkspaceBrandId';

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryParams?: any;
  options?: Array<ISingleOption>;
}

export const ExpertFilter: FC<Props> = ({
  onFilterSelect,
  queryParams,
  options,
  ...rest
}) => {
  const { role, brand } = useUser();
  const workspaceBrandId = useWorkspaceBrandId();
  const brandId: number = workspaceBrandId || (brand ? brand[0].id : 0);
  const [experts, setExperts] = useState<Array<ISingleOption>>([]);
  const debounceRef = useRef<ReturnType<typeof setTimeout>>();

  const fetchExperts = (search?: string) => {
    let endpoint = `/brands/${brandId}/pros`;
    if (isInternal(role)) {
      const params = new URLSearchParams();
      if (search) params.set("search", search);
      endpoint = `/users/pros?${params.toString()}`;
    }
    axiosInstant
      .get(endpoint)
      .then((response) => {
        const output = response.data.rows.map((e: ISinglePro) => {
          if (!e.userid || !e.displayName) return null;
          return {
            id: e.userid,
            name: e.displayName,
            image: cldUrl(e.avatar, { w: 80, h: 80, crop: "fill", gravity: "face" }),
          };
        });
        setExperts(output.filter((e: ISingleOption) => !!e));
      })
      .catch((error) => {
        console.error(error.response);
      });
  };

  useEffect(() => {
    fetchExperts();
  }, []);

  const handleSearch = useCallback((text: string) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchExperts(text);
    }, 300);
  }, [role, brandId]);

  const expertsList = options && options.length > 0 ? options : experts;

  return (
    <SingleFilter
      {...rest}
      {...getFilterProps(expertsList, "proId", "Expert")}
      icon={IconExpert}
      updateSearch={onFilterSelect}
      thumbnails
      onSearchChange={handleSearch}
    />
  );
};
